import {RoomBaseApiService} from "@/core/service/room.baseapi.service";
import {ErrorWrapper, ResponseWrapper} from "@/core/service/util";

class RoomChatBotService extends RoomBaseApiService {
    constructor(props) {
        super(props);
    }

    async sendChatMessage(data) {
        try {
            const response = await this.request({ auth: true }).post(
                `/api/v3/room/${this.getRoomId()}/ai-chat`,
                {
                    ...data
                }
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
}

export const roomChatBotService = new RoomChatBotService()